import { apiInstance } from "./httpService";
import { all, call, put, takeLatest } from "redux-saga/effects";
import _ from "lodash";
import * as authActions from "../action/auth";
import constants from "../constants";
import NotificationMessage from "../../src/utils/NotificationMessage";

export const httpErrorHelpers = (error, ignoreToast = false) => {
  if (error.response) {
    const statusCode = _.get(error.response, "status", null);
    if (statusCode === 401) {
      return { type: constants.LOGOUT };
    }

    if (statusCode === 422) {
      const errorsStatus = _.get(error.response, ["data", "errors"], {});
      const statusMessage = _.get(error.response, ["data", "message"], "");
      if (statusMessage && !ignoreToast) {
        NotificationMessage.error(statusMessage);
      }
      return { type: constants.SET_OFF };
    }
    const messages = _.get(error.response, "data", null);
    const statusMessage = _.get(error.response, ["data", "message"], "");

    if (!_.isEmpty(messages.message) && !ignoreToast) {
      // Toast.error(messages.message);
      // const { text, type } = messages[0];
      // type === "error"
      //   ? !overrideErrorToastToInfo
      //     ? Toast.error(text)
      //     : Toast.info(text)
      //   : Toast.info(text);
      NotificationMessage.error(statusMessage);
    } else {
      const unknownErrorMsg = `Unknown ${statusCode} Error`;
      NotificationMessage.error(unknownErrorMsg);
    }
    return error.response;
  } else if (error.request) {
    const statusTimeout = _.get(error.request, ["timeout"], null);
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // NotificationMessage.error(statusTimeout);
  }

  const status = _.get(error, "response.status", null);
  const errorMessage = _.get(error, "message", "");

  if (!_.isEmpty(error.message)) {
    // !ignoreToast
    //     ? !overrideErrorToastToInfo
    //         ? Toast.error(error.message)
    //         : Toast.info(error.message)
    //     : false;
    NotificationMessage.error(errorMessage);
  } else {
    const unknownErrorMsg = `Unknown ${status} Error`;
    //   Toast.error(unknownErrorMsg);
    NotificationMessage.error(unknownErrorMsg);
  }
};

export const get = async (url, dispatch, returnType) => {
  try {
    const axios = apiInstance(null, returnType);

    const response = await axios.get(url);

    if (response.status === 200) {
      return response.data;
    }
    return Promise.reject("Unknown Server Error");
  } catch (e) {

    return Promise.reject(httpErrorHelpers(e));
  }
};

export const post = async (
  url,
  data,
  isToast = false,
  ignoreToast = false,
  successMessage = "",
  headerOptions,
  hideSuccessToast=false
) => {
  try {
    const axios = apiInstance(headerOptions);
    const response = await axios.post(url, data);
    if (response.status === 200) {
      if(!hideSuccessToast) {
        if (successMessage) {
          NotificationMessage.success(successMessage);
        } else {
          NotificationMessage.success(
            _.get(response, ["data", "message"], "Success"),
          );
        }
      }
      return response.data;
    }
    return Promise.reject("Unknown Server Error");
  } catch (e) {
    return Promise.reject(httpErrorHelpers(e, ignoreToast));
  }
};

export const del = async (
  url,
  isToast = false,
  ignoreToast = false,
  successMessage = "",
  headerOptions,
) => {
  try {
    const axios = apiInstance(headerOptions);
    const response = await axios.delete(url);
    if (response.status === 200) {
      if (successMessage) {
        NotificationMessage.success(successMessage);
      } else {
        NotificationMessage.success(
          _.get(response, ["data", "message"], "Deleted successfully"),
        );
      }
      return response.data;
    }

    return Promise.reject("Unknown Server Error");
  } catch (e) {
    return Promise.reject(httpErrorHelpers(e, ignoreToast));
  }
};

export const patch = async (
  url,
  data,
  isToast = false,
  ignoreToast = false,
  successMessage = "",
  headerOptions,
) => {
  try {
    const axios = apiInstance(headerOptions);
    const response = await axios.patch(url, data);
    if (response.status === 200) {
      if (successMessage) {
        NotificationMessage.success(successMessage);
      } else {
        NotificationMessage.success(
          _.get(response, ["data", "message"], "Success"),
        );
      }
      return response.data;
    }
    return Promise.reject("Unknown Server Error");
  } catch (e) {
    return Promise.reject(httpErrorHelpers(e, ignoreToast));
  }
};
